import FormDrawer from "components/__new/common/form-drawer";
import imgComplianceOnboard from "assets/images/bgs/compliance-onboard.png";


export const WelcomePopup = (props) => {
    const { isOpen, setIsOpen } = props;

    return (
        <FormDrawer display="center" size="lg" isBackdropBlur={true} isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-8">
                
                <div className="h-64 flex rounded-lg border border-[#E5E7EB] overflow-hidden" style={{background: "radial-gradient(58% 58% at 50% 42%, rgba(240, 240, 240, 0.45) 0%, rgba(218, 218, 218, 0.45) 100%)"}}>
                    <img src={imgComplianceOnboard} alt="compliance onboard" className="mx-auto object-contain" />
                </div>

                <div className="mt-6 text-center">
                    <div className="font-semibold text-lg">
                        Welcome to Earnipay
                    </div>
                    <div className="text-fade">
                        To access our secure and seamless services, we require specific information for business registration verification.
                    </div>
                </div>

                <div className="mt-8 flex space-x-3 justify-start">
                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-ep-primary btn-lg btn-block">
                        Continue
                    </button>
                </div>
                
            </div>
        </FormDrawer>
    )
}